import { Button, Chip, makeStyles } from "@material-ui/core";
import { Check, Clear } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useAuth } from "../../../../context/auth";
import {
  getMinutesParticipants,
  setAttendances,
} from "../../../../services/minutes.service";
import { Select } from "../../../Common/Select";
import Toastmessage from "../../../Common/ToastMessage";
import { checkAccess } from "../../utils/index";
import {
  CheckAttendanceButton,
  CheckNonAttendanceButton,
  ConcludeButtonContainer,
  Container,
  Header,
  ListRow,
  ParticipantRowItemContainer,
  PaticipantsList,
} from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
    marginTop: "5vh",
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },

  chip: {
    margin: 2,
  },
}));

const ConfirmAttendanceModal = ({
  setModalStatus,
  onSuccess,
  minuteId,
  companiesOptions,
  t,
}) => {
  const { userAccess } = useAuth();
  const history = useHistory();
  const classes = useStyles();

  const [toastMessage, setToastMessage] = useState({
    message: "",
    type: "error",
    open: false,
  });

  const [participants, setParticipants] = useState([]);
  const [canConfirmParticipants, setCanConfirmParticipants] = useState(false);

  useEffect(() => {
    if (userAccess) {
      const hasAccess = checkAccess(userAccess, "listMinutes");
      const hasAccessToConfirmParticipants = checkAccess(
        userAccess,
        "confirmParticipants"
      );

      setCanConfirmParticipants(hasAccessToConfirmParticipants);

      if (!hasAccess) {
        history.push("/");
      }

      getMinutesParticipants(minuteId).then((response) => {
        const newParticipants = response.data.map((item) => ({
          name: item.participant,
          role: item.cargo,
          id: item.id,
          place: item.local,
          presence: item.presence,
          abbreviation: item.abbreviation,
          companies: item?.companies
            ? item.companies?.map((item) => ({
                id: item.companyId,
                name: `${item.companyName} - ${item.companyAbbreviation}`,
              }))
            : [],
          ...(!item.presence && {
            companies: companiesOptions.map((item) => ({
              id: item.companyId,
              name: `${item.companyName} - ${item.companyAbbreviation}`,
            })),
          }),
        }));

        setParticipants(newParticipants);
      });
    }
  }, [minuteId, userAccess]);

  const handleCheckAttendance = (participantId) => {
    const participantPresent = participants.find(
      (item) => item.id === participantId
    )?.presence;

    if (participantPresent) {
      setParticipants(
        participants.map((participant) => {
          if (participant.id === participantId) {
            return {
              ...participant,
              presence: false,
            };
          } else {
            return participant;
          }
        })
      );
    } else {
      setParticipants(
        participants.map((participant) => {
          if (participant.id === participantId) {
            return {
              ...participant,
              presence: true,
            };
          } else {
            return participant;
          }
        })
      );
    }
  };

  const handleCheckNonAttendance = (participantId) => {
    const participantPresent = participants.find(
      (item) => item.id === participantId
    )?.presence;

    if (!participantPresent && typeof participantPresent === "boolean") {
      setParticipants(
        participants.map((participant) => {
          if (participant.id === participantId) {
            return {
              ...participant,
              presence: true,
            };
          } else {
            return participant;
          }
        })
      );
    } else {
      setParticipants(
        participants.map((participant) => {
          if (participant.id === participantId) {
            return {
              ...participant,
              presence: false,
            };
          } else {
            return participant;
          }
        })
      );
    }
  };

  const handleConclude = async () => {
    const allAttendancesFilled = !participants.find(
      (participant) =>
        !participant.presence && typeof participant.presence !== "boolean"
    );

    if (!allAttendancesFilled) {
      setToastMessage({
        message: "Preencha a presença de todos os participantes.",
        type: "error",
        open: true,
      });

      return;
    }

    const formattedParticipants = participants.map((participant) => ({
      ...participant,
      companyIds: participant.companies.map((item) => item.id),
    }));

    const setAttendancesResponse = await setAttendances({
      participants: formattedParticipants,
      minuteId,
    });

    if (setAttendancesResponse.error) {
      setToastMessage({
        message: "Ocorreu um erro ao adicionar as presenças.",
        type: "error",
        open: true,
      });

      return;
    }

    onSuccess();
  };

  return (
    <>
      <Toastmessage
        message={toastMessage.message}
        type={toastMessage.type}
        open={toastMessage.open}
        autoHideDuration={toastMessage.autoHideDuration}
        close={() =>
          setToastMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
      <Container>
        <Header>
          <span
            style={{ float: "right", cursor: "pointer" }}
            onClick={() => {
              setModalStatus(false);
            }}
          >
            [X] Fechar
          </span>
          <span className={classes.titleModal}>
            {t(`menu.minutes.confirmAttendance.title`)}
          </span>
        </Header>
        <PaticipantsList>
          <ListRow isHeader={true}>
            <div>
              <span>{t("name")}</span>
            </div>
            <div>
              <span>{t("role")}</span>
            </div>
            <div>
              <span>{t("menu.managementProfiles.abbreviation")}</span>
            </div>
            <div>
              <span>{t("presence")}</span>
            </div>
            <div>
              <span>{t("slots.companies")}</span>
            </div>
          </ListRow>

          {participants.map((participant) => (
            <ListRow key={participant.id}>
              <ParticipantRowItemContainer>
                <span>{participant.name}</span>
              </ParticipantRowItemContainer>

              <ParticipantRowItemContainer>
                <span>{participant.role}</span>
              </ParticipantRowItemContainer>

              <ParticipantRowItemContainer>
                <span>{participant.abbreviation}</span>
              </ParticipantRowItemContainer>

              <ParticipantRowItemContainer>
                <CheckAttendanceButton
                  selected={participant.presence}
                  onClick={() => handleCheckAttendance(participant.id)}
                >
                  <Check />
                </CheckAttendanceButton>
                <CheckNonAttendanceButton
                  selected={
                    !participant.presence &&
                    typeof participant.presence === "boolean"
                  }
                  onClick={() => handleCheckNonAttendance(participant.id)}
                >
                  <Clear />
                </CheckNonAttendanceButton>
              </ParticipantRowItemContainer>

              <ParticipantRowItemContainer style={{ marginBottom: "18px" }}>
                <Select
                  id="companies"
                  options={
                    companiesOptions?.map((item) => ({
                      id: item.companyId,
                      name: `${item.companyName} - ${item.companyAbbreviation}`,
                    })) ?? []
                  }
                  getOptionSelected={(option, value) => option.id === value.id}
                  value={participant.companies}
                  label={t("slots.companies")}
                  setValue={(values) => {
                    setParticipants((ogValue) =>
                      ogValue.map((v) =>
                        v.id !== participant.id
                          ? v
                          : { ...v, companies: values }
                      )
                    );
                  }}
                  multiple={true}
                  renderTags={(selectedValues) => {
                    return selectedValues.map((option) => (
                      <Chip
                        className={classes.chip}
                        key={option.id}
                        onDelete={() => {
                          setParticipants((ogValue) =>
                            ogValue.map((v) =>
                              v.id !== participant.id
                                ? v
                                : {
                                    ...v,
                                    companies: participant.companies.filter(
                                      (v) => v.id !== option.id
                                    ),
                                  }
                            )
                          );
                        }}
                        onClick={() => {
                          setParticipants((ogValue) =>
                            ogValue.map((v) =>
                              v.id !== participant.id
                                ? v
                                : {
                                    ...v,
                                    companies: participant.companies.filter(
                                      (v) => v.id !== option.id
                                    ),
                                  }
                            )
                          );
                        }}
                        variant="outlined"
                        label={option.name}
                      />
                    ));
                  }}
                />
              </ParticipantRowItemContainer>
            </ListRow>
          ))}

          {participants.length < 1 && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p>{t(`menu.minutes.confirmAttendance.noneParticipants`)}</p>
            </div>
          )}
        </PaticipantsList>

        <ConcludeButtonContainer>
          <Button
            className={classes.button}
            variant="contained"
            onClick={handleConclude}
            disabled={!canConfirmParticipants}
          >
            {t("menu.minutes.confirmAttendance.conclude")}
          </Button>
        </ConcludeButtonContainer>
      </Container>
    </>
  );
};

export default ConfirmAttendanceModal;
